import { SimpleValueMap, VariantServices } from "@/types/types.ts";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";

const SCAFFOLD_PARAMETER_PREFIX = "pdp-scaffold-";

// Filter out any experience without dlv-threshold in object key
export const filterDeliveryThresholdExperiences = (
  experiences?: Experiences,
) => {
  if (!experiences || experiences.length === 0) return {};

  return experiences.reduce((acc: SimpleValueMap, { parameters }) => {
    if (!parameters) {
      return acc;
    }

    Object.entries(parameters).forEach(([key, value]) => {
      if (isScaffoldParameter(key)) {
        const cleanKey = removePdpScaffoldPrefix(key);
        if (
          cleanKey.includes("dlv-threshold") &&
          (typeof value === "string" ||
            typeof value === "boolean" ||
            typeof value === "number")
        ) {
          acc[cleanKey] = value;
        }
      }
    });

    return acc;
  }, {});
};

function isScaffoldParameter(parameterName: string): boolean {
  return parameterName.startsWith(SCAFFOLD_PARAMETER_PREFIX);
}

function removePdpScaffoldPrefix(s: string): string {
  return s.replace(new RegExp(`^${SCAFFOLD_PARAMETER_PREFIX}`), "");
}

export const hasExtendedWarranties = (services: VariantServices) =>
  services?.some(({ __typename }) => __typename === "ExtendedWarranty");
